export const CALCULATION = "CALCULATION";
export const SUMMARY_REPORT = "SUMMARY_REPORT";
export const MULTIPLE_STATE_ENTITY = "Multiple";

export const BUSY_CALCULATION_STATUS = ["QUEUED", "PROCESSING"];

export const TAX_FILE_SHEET_NAME = "Sheet0";

export const RECORD_ID_COLUMN = "RecordID";

export const XLSX_EXTENSION = ".xlsx";

export const MAX_INVALID_CELLS_SHOWN = 3;

export const AMOUNT_COLUMNS = [
  "InvoiceAmount",
  "CalculatedAmount",
  "TaxAmount",
  "TaxRate",
  "StateTaxableAmount",
  "CountyTaxableAmount",
  "CityTaxableAmount",
  "DistrictTaxableAmount",
  "ParishTaxableAmount",
  "StateTaxAmount",
  "CountyTaxAmount",
  "CityTaxAmount",
  "DistrictTaxAmount",
  "ParishTaxAmount",
] as const;

export const EXPECTED_TAX_FILE_COLUMNS = [
  "VENDOR_NAME",
  "VendorNumber",
  "VENDOR_SITE_CODE",
  "INVOICE_NUM",
  "ImageNum",
  "PoNum",
  "INVOICE_DATE",
  "INVOICE_AMOUNT",
  "LINE_NUMBER",
  "Co",
  "Loc",
  "CC",
  "Acct",
  "Prod",
  "GeoMkt",
  "Proj",
  "CalculatedAmount",
  "LINE_TYPE_LOOKUP_CODE",
  "ACCOUNTING_DATE",
  "DESCRIPTION",
  "STATE",
  "Status",
  "COA_Acct_Description",
  "ITEM_DESCRIPTION",
  "PCInvoiceLink",
  "spend_level_1",
  "spend_level_2",
  "spend_level_3",
  "Supplier_City",
  "Supplier_State",
  "Final_AddressLine1",
  "Final_AddressLine2",
  "Final_AddressLine3",
  "Final_City",
  "Final_State",
  "Final_ZipCode",
  "Final_Country",
  "Vertex Category",
  "PRODCLASS",
  "Company Code",
  "Review Type Vendor or Transaction",
  "Review Reason",
  "Review Result",
  "RecordID",
  "BuildingId",
  "TaxAmount",
  "TaxRate",
  "Geocode",
  "RowErrorType",
  "StateTaxableAmount",
  "CountyTaxableAmount",
  "CityTaxableAmount",
  "DistrictTaxableAmount",
  "ParishTaxableAmount",
  "StateTaxAmount",
  "CountyTaxAmount",
  "CityTaxAmount",
  "DistrictTaxAmount",
  "ParishTaxAmount",
] as const;
